/* TD 2026-10-12 WEIGHT-A — the body-weight line under the weight cards ([data-td-wa-line], snippets/td-variant-picker.liquid)
   follows every change of the selection at once: on product pages and in the quick-buy sheet on any page (loaded from
   layout/theme.liquid after custom.js, so its listeners run after the sold-out filters of P01 and custom.js).
   The checked values of ALL options are looked up in the lists next to the line ([data-td-wa-map], built by the same
   rules as the server line): "v" = [option values, own range] of the existing variants (own range null = the variant has
   no metafield → the range of its weight + size from "ws" = [weight, size, range]; '' = no valid range). A combination
   that is not an existing variant, no list or nothing checked → the line is emptied and hidden, never left with another
   variant's range (Codex R1 + R2); the theme's re-render then brings the server line (empty for a missing variant).
   Runs: on every option change, when a quick-buy sheet opens (after the filters), after every re-render, once at start. */
(function () {
  'use strict';
  if (window.tdWaLine) return;
  window.tdWaLine = true;

  function sync(picker) {
    var line = picker.querySelector('[data-td-wa-line]');
    var textEl = line && line.querySelector('[data-td-wa-text]');
    if (!textEl) return;
    var text = '';
    try {
      var mapEl = picker.querySelector('script[data-td-wa-map]');
      var data = mapEl ? JSON.parse(mapEl.textContent) : null;
      if (data && data.w) {
        var sel = {};
        picker.querySelectorAll('input[data-option-position]:checked').forEach(function (i) {
          sel[i.getAttribute('data-option-position')] = i.getAttribute('data-option-value');
        });
        var row = null;
        (data.v || []).some(function (r) {
          var o = r[0] || [];
          for (var p = 0; p < o.length; p++) if (sel[p + 1] !== o[p]) return false;
          row = r;
          return true;
        });
        var range = '';
        if (row && row[1] === null) {
          var w = sel[data.w];
          var s = data.s ? sel[data.s] : '';
          (data.ws || []).some(function (e) {
            if (e[0] !== w || e[1] !== s) return false;
            range = e[2] || '';
            return true;
          });
        } else if (row) {
          range = row[1] || '';
        }
        if (range) text = (data.label || '') + ' ' + String(range).replace(/ kg/g, '\u00a0kg');
      }
    } catch (err) {
      text = '';
    }
    if (textEl.textContent !== text) textEl.textContent = text;
    line.hidden = !text;
  }

  function syncIn(root) {
    (root || document).querySelectorAll('[data-td-variant-picker]').forEach(sync);
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-td-variant-picker] input[data-option-position]')) return;
    var picker = input.closest('[data-td-variant-picker]');
    if (picker) sync(picker);
  });

  /* quick-buy sheet: its content is inserted on open; custom.js and P01 run their filters in the same (capture) events,
     so this runs after them. Dialog events do not bubble → capture. */
  ['dialog:before-show', 'dialog:after-show'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var modal = e.target;
      if (modal && modal.matches && modal.matches('quick-buy-modal')) queueMicrotask(function () { syncIn(modal); });
    }, true);
  });

  /* after Prestige swapped the picker (product:rerender does not bubble and fires before the swap → capture + microtask) */
  document.addEventListener('product:rerender', function () {
    queueMicrotask(function () { syncIn(); });
  }, true);

  syncIn();
})();
